export const REQUEST_PRIVACY_POLICY_INFO = 'requestPrivacyPolicyInfo';
export const EXECUTE_TOKEN = 'executeToken';
export const SET_TOKEN = 'setToken';
export const SET_IS_TOKEN_VALID = 'setIsTokenValid';
export const SET_CLIENT_NAME = 'setClientName';
export const SET_EXECUTING_TOKEN = 'executingToken';
